import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { REQUEST_TARGET_MODULES } from '../../../../../../Library/APIsTarget';
import { checkScheduleConflicts, compareSchedulesWithCourses, generateDaysArray, groupSchedulesByDay } from '../../../../../Student/Reregistration-New/Components/PreviewTimetables';
import { AlertNotif } from '../../../../../../Library/AlertNotif';
import LoadingBtn from '../../../../../Widgets/LoadingBtn';
import { EncodeURIComponentSafe } from '../../../../../../Library/GlobalHelper';

export default function PreviewTimetables({ termid, courses, setLoading, has_conflict, setHasConflict }) {
  const current_day = moment();

  const [start_semester, setStart_semester] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const [schd, setSchd] = useState({ loading: false, data: [], message: "" });
  const [unmatchedSchedules, setUnmatchedSchedules] = useState([]);
  const [daysArr, setDaysArr] = useState([]);
  const [groupedSchedules, setGroupedSchedules] = useState([]);
  const list_sectionid = courses
    ? courses
      .filter(item => item.action_type && item.action_type === "add")
      .map((c) => c?.section_id)
      .filter((id) => id !== undefined && id !== null)
      .join(",")
    : "";

  const GET_MILESTONE_START_SEMESTER = async (term_id, sections) => {
    try {
      setLoading(false);
      setStart_semester({ loading: true, data: [], message: "" });
      setSchd({ loading: true, data: [], message: "" });
      const param = {
        atpid: term_id,
        view_all: 1,
      };
      const param_post = {
        parameters: param,
        target_data: "GET_ACAD_MSTONE_BY_ACAD",
      };

      const results = await REQUEST_TARGET_MODULES(param_post);
      if (results.data && Object.values(results.data).length > 0) {
        const key_semester_start = "asc.atp.milestone.FirstDayOfClasses";
        const find_by_key = results.data.find(
          (item) => item.mstone_type_id === key_semester_start
        );
        if (find_by_key) {
          const monday = moment(find_by_key?.start_dt || "")
            .startOf("weeks")
            .format("YYYY-MM-DD");
          const sunday = moment(find_by_key?.start_dt || "")
            .endOf("weeks")
            .format("YYYY-MM-DD");

          setStart_semester({ loading: false, data: find_by_key, message: "" });
          ReloadSchd(monday, sunday, sections);
        } else {
          const monday = moment(current_day)
            .startOf("weeks")
            .format("YYYY-MM-DD");
          const sunday = moment(current_day)
            .endOf("weeks")
            .format("YYYY-MM-DD");
          const daysArray = generateDaysArray(monday, sunday);
          setDaysArr(daysArray);
          setStart_semester({ loading: false, data: [], message: "" });
          setUnmatchedSchedules(courses);
          setSchd({ loading: false, data: [], message: "" });
          setLoading(true);
        }
      } else {
        const monday = moment(current_day)
          .startOf("weeks")
          .format("YYYY-MM-DD");
        const sunday = moment(current_day).endOf("weeks").format("YYYY-MM-DD");
        const daysArray = generateDaysArray(monday, sunday);
        setDaysArr(daysArray);
        setUnmatchedSchedules(courses);
        setStart_semester({ loading: false, data: [], message: "" });
        setSchd({ loading: false, data: [], message: "" });
        setLoading(true);
      }      
    } catch (error) {
      setSchd({ loading: true, data: [], message: error?.message });
    }
  };

  useEffect(() => {
    if (termid && list_sectionid) {
      try {
        GET_MILESTONE_START_SEMESTER(termid, list_sectionid);
      } catch (error) {
        setSchd({ loading: false, data: [], message: error?.message });
      }
    }
  }, [termid, list_sectionid]);

  const ReloadSchd = async (start_dt, end_dt, sections) => {
    setLoading(false);
    setSchd({ loading: true, data: [], message: "" });
    const param = {
      grouped: "True",
      start_dt,
      end_dt,
      section_id: EncodeURIComponentSafe(sections),
    };
    const param_post = {
      parameters: param,
      target_data: "GET_SCHD",
    };

    const results = await REQUEST_TARGET_MODULES(param_post);
    if (results.data && Object.values(results.data).length > 0) {
      const data_schd = results.data.map((item) => ({
        start_dt: item?.start_dt,
        end_dt: item?.end_dt,
        start_day: moment(item?.start_dt).format("dddd"),
        end_day: moment(item?.end_dt).format("dddd"),
        coursetitle: item?.course?.coursetitle || "",
        coursecredit: item?.course?.credit || "",
        coursecode: item?.course?.code || "",
        section_id: item?.section_id || "",
        is_conflict: false,
      }));

      const data_schedule_sections = data_schd.map((s) => s?.section_id);
      const unmatched = compareSchedulesWithCourses(
        data_schedule_sections,
        courses.filter(item => item.action_type && item.action_type === "add")
      );
      setUnmatchedSchedules(unmatched);

      const { conflicts, updatedSchedules } = checkScheduleConflicts(data_schd);
      if (conflicts.length > 0) {
        setSchd({
          loading: false,
          data: updatedSchedules,
          message: "",
        });
        setHasConflict(true);
      } else {
        setSchd({ loading: false, data: updatedSchedules, message: "" });
        setHasConflict(false);
      }

      const daysArray = generateDaysArray(start_dt, end_dt);
      setDaysArr(daysArray);
      const groupedSchedules = groupSchedulesByDay(
        start_dt,
        end_dt,
        updatedSchedules
      );
      setGroupedSchedules(groupedSchedules);
      setSchd({ loading: false, data: updatedSchedules, message: "" });
      setLoading(true);
    } else {
      setSchd(results);
      const monday = moment(current_day).startOf("weeks").format("YYYY-MM-DD");
      const sunday = moment(current_day).endOf("weeks").format("YYYY-MM-DD");
      const daysArray = generateDaysArray(monday, sunday);
      setDaysArr(daysArray);
      setUnmatchedSchedules(courses);
      setGroupedSchedules([]);
      setLoading(true);
    }
  };

  try {
    return (
      <div>
        <div className="table-responsive" id="table-timetables">
          <table className="table table-borderless table-vertical-center">
            <thead>
              <tr
                className="text-center text-uppercase "
                style={{ backgroundColor: "#f0f6fe" }}
              >
                {daysArr &&
                  Object.values(daysArr).length > 0 &&
                  daysArr.map((day, index) => (
                    <th
                      key={index}
                      className="text-center"
                      style={{ width: "150px" }}
                    >
                      <div className="font-weight-bolder font-size-lg">
                        {day.dayName}
                      </div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {schd.loading ? (
                <tr>
                  <td colSpan={7}>
                    <LoadingBtn />
                  </td>
                </tr>
              ) : schd.message ? (
                <tr>
                  <td colSpan={7}>
                    <AlertNotif color="danger" message={schd.message} />
                  </td>
                </tr>
              ) : daysArr && Object.values(daysArr).length > 0 ? (
                <tr>
                  {daysArr.map((day, dayIndex) => {
                    const daySchedules = (
                      groupedSchedules[day.dayName] || []
                    ).sort((a, b) => {
                      const startA = moment(a.start_dt);
                      const startB = moment(b.start_dt);
                      return startA.diff(startB);
                    });

                    return (
                      <td key={dayIndex} className="align-top p-2">
                        {daySchedules.length > 0 ? (
                          <div className="d-flex flex-column gap-2">
                            {daySchedules.map((schedule, scheduleIndex) => (
                              <div
                                key={scheduleIndex}
                                className={`mb-2 rounded p-2 ${schedule.is_conflict === true
                                    ? "text-danger bg-light-danger border border-danger"
                                    : "text-dark border bg-light"
                                  }`}
                              >
                                <div className="d-flex align-items-start">
                                  <div className="mr-3">
                                    <span className="font-weight-bolder h1">
                                      ·
                                    </span>
                                  </div>
                                  <div>
                                    <span className="font-weight-bolder">
                                      <span className="d-block font-size-sm">
                                        {moment(schedule?.start_dt).format(
                                          "HH:mm A"
                                        )}{" "}
                                        -{" "}
                                        {moment(schedule?.end_dt).format(
                                          "HH:mm A"
                                        )}
                                      </span>
                                      <span className='font-size-sm'>{schedule?.coursetitle}</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="mb-0 text-center">-</p>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ) : (
                <tr>
                  <td colSpan={7}>No record found</td>
                </tr>
              )}
            </tbody>
            <tfoot>
              {has_conflict ? (
              <tr>
                <td colSpan={7} className="px-8" style={{ backgroundColor: "#f0f6fe" }}>
                  <span className="d-block font-weight-bold">Notes:</span>
                  <div className="d-flex align-items-center">
                    <div
                      className="p-3 rounded bg-danger"
                      style={{ width: "15px" }}
                    ></div>
                    <div className="font-weight-bolder ml-1 font-size-lg">
                      The time conflict needs to be resolved by AOO before this PCF can be approved. Please wait for further notice.
                    </div>
                  </div>
                </td>
              </tr>
              ) : ""}
              {unmatchedSchedules.length > 0 && (
                <tr>
                  <td colSpan={7} className="p-2">
                    <div className="bg-light-warning p-5 rounded border border-warning">

                      <h4>Course Schedule Not Available</h4>
                      <span className="font-weight-bold font-size-lg">
                        The following course does not have a scheduled timetable
                        yet.
                      </span>

                      <div className="mt-2">
                        {unmatchedSchedules.map((m, index) => (
                          <span className="badge badge-warning mr-1 h6" key={index}>
                            {m?.detail?.course_code} {m?.detail?.coursetitle}
                          </span>
                        ))}
                      </div>

                      {/* <div className="row mt-2">
                        {unmatchedSchedules.map((m, index) => (
                          <div className="col-auto p-1" key={index}>
                            <div className="border rounded bg-white p-3 font-size-sm">
                              <span className="font-weight-bolder d-block">
                                {m?.detail?.coursetitle}
                              </span>
                              <span className="text-muted">
                                {m?.detail?.course_code}
                              </span>
                              <div className="border-top my-3"></div>
                              <div className="d-flex align-items-center justify-content-between">
                                <span className="d-block text-muted mr-2">{m?.section_id}</span>
                                <span className="badge badge-light">
                                  {m?.detail?.course_credit} SKS
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div> */}
                    </div>
                  </td>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      </div>
    );
  } catch (error) {
    return <AlertNotif message={error.message} color={'danger'} />
  }
}
